"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const Style_1 = require("./Style");
function adj(style) {
    const { textAlign = "right" } = style;
    style.textAlign = textAlign;
    return style;
}
let defaultStyle;
class NumberStyle extends Style_1.Style {
    static get DEFAULT() {
        return defaultStyle ? defaultStyle : (defaultStyle = new NumberStyle());
    }
    constructor(style = {}) {
        super(adj(style));
    }
    clone() {
        return new NumberStyle(this);
    }
}
exports.NumberStyle = NumberStyle;
